import { gql } from 'graphql-tag';

/**
 * The GraphQL-Fields for Addresses.
 */
export const ADDRESS_FIELDS = gql`
  fragment AddressFields on Address {
    organization
    street
    houseNumber
    postCode
    city
    country
    countryName
  }
`;

/**
 * The GraphQL-Fields for Intervals.
 */
export const INTERVAL_FIELDS = gql`
  fragment IntervalFields on Interval {
    start
    end
  }
`;

/**
 * The GraphQL-Fields for Measures.
 */
export const MEASURE_FIELDS = gql`
  fragment MeasureFields on Measure {
    value
    unit
  }
`;

/**
 * The GraphQL-Fields for nullable Measures.
 */
export const NULLABLE_MEASURE_FIELDS = gql`
  fragment NullableMeasureFields on NullableMeasure {
    value
    unit
  }
`;

/**
 * The GraphQL-Fields for Products.
 */
export const PRODUCT_FIELDS = gql`
  fragment ProductFields on Product {
    id
    name
    marketingDeadline {
      deadlineForEarliestForecast
      daysBeforeDelivery
      minutesBeforeIntradayDelivery
    }
  }
`;

export const DEVICE_FIELDS = gql`
  fragment DeviceFields on Device {
    externalName
    id
    internalId
    name
    products {
      ...ProductFields
    }
    deadlines {
      type
      deadline {
        deadlineForEarliestForecast
        daysBeforeDelivery
        minutesBeforeIntradayDelivery
      }
    }
  }
`;
